import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AppStateService} from '../app-state.service';

export const COLORS = [
  {backgroundColor: '#CD4313', textColor: 'white'},
  {backgroundColor: '#F26529', textColor: 'white'},
  {backgroundColor: '#F7941E', textColor: 'white'},
  {backgroundColor: '#F7B806', textColor: 'white'},
  {backgroundColor: '#9DC445', textColor: 'white'},
  {backgroundColor: '#558B2F', textColor: 'white'},
  {backgroundColor: '#00A798', textColor: 'white'},
  {backgroundColor: '#4CC1E0', textColor: 'black'},
  {backgroundColor: '#006064', textColor: 'white'},
  {backgroundColor: '#607D8B', textColor: 'white'},
  {backgroundColor: '#5E2B63', textColor: 'white'},
  {backgroundColor: '#7E57C2', textColor: 'white'},
  {backgroundColor: '#37474F', textColor: 'white'}
];

export const EMPTY_COLOR = {backgroundColor: '#999', textColor: 'white'};
export const VT_TALENT_COLOR = {backgroundColor: '#BBB', textColor: 'black'};

function colorForName(name: string) {
  let hash = 0;

  for (const character of name) {
    hash += character.charCodeAt(0);
  }

  hash %= COLORS.length;

  return name ? COLORS[hash] : EMPTY_COLOR;
}

@Component({
  selector: 'user-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent implements OnChanges {

  @Input() data: AvatarData | string;
  @Input() filled = true;

  initials: string;
  backgroundColor: string | null = null;
  borderColor: string | null = null;
  textColor: string | null = null;
  vtBackgroundColor: string | null = null;
  vtBorderColor: string | null = null;
  vtTextColor: string | null = null;
  avatarUrl: string | null = null;
  brand$ = this.AppState.brand$;

  constructor(private AppState: AppStateService) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data) {
      let data: AvatarData;
      if (typeof this.data === 'string') {
        let split = this.data.split(/\s+/);
        data = {
          firstName: split[0] || '',
          lastName: (split.length > 1 ? split[split.length - 1] : null) || '',
          avatarUrl: ''
        };
      } else {
        data = this.data;
        this.avatarUrl = data.avatarUrl || '';
      }
      this.initials = ((data.firstName[0] || '') + (data.lastName[0] || '')).toUpperCase();
      const colors = colorForName(data.firstName + data.lastName);
      this.backgroundColor = this.filled && colors.backgroundColor;
      this.borderColor = !this.filled && colors.backgroundColor;
      this.textColor = this.filled && colors.textColor;
      this.vtBackgroundColor = this.filled && EMPTY_COLOR.backgroundColor;
      this.vtBorderColor = !this.filled && VT_TALENT_COLOR.backgroundColor;
      this.vtTextColor = this.filled && EMPTY_COLOR.textColor;
    }
  }
}

